import { Bbox } from "./helpers/map"
import packageJson from "../../package.json"
import { setApiUrl, setEnv } from "./helpers/api"

// API urls
export const PROD_API = "https://api.lock8.me/api/"
export const TEST_API = "https://api-test.lock8.me/api/"

/**
 * NOTE
 * If you don't have a backend instance up and running locally, and you want to interrogate
 * remote endpoints, you must start the proxy server with 'yarn proxy'.
 * Then ceck out proxy env vars to know what's the target (test or production).
 */
export const LOCAL_API = "http://localhost:8000/api/"

// get env by hostname (default to prod)
const hostname = window?.location?.hostname
const env: "local" | "testing" | "staging" | "production" = setEnv({ hostname })

export const ENV = env

export const IS_LOCAL = ENV === "local"
export const IS_TEST = ENV === "testing"
export const IS_STAGE = ENV === "production"
export const IS_PROD = ENV === "production"

// API url based on environment (defaults to production)
export const API_URL = setApiUrl()

if (hostname === "localhost") {
  console.log(API_URL)
}

// nq mapbox token
// export const MAPBOX_TOKEN =
//   "pk.eyJ1Ijoibm9xdWFydGVyIiwiYSI6ImNraHl5czY1dzB5NnMycW1wMWhyaDJjMW0ifQ.e3Doof2xkFEN0tRM_GdfWg"

// noa mapbox token
export const MAPBOX_TOKEN =
  "pk.eyJ1Ijoibm9hdGVjaG5vbG9naWVzaW5jIiwiYSI6ImNsNnoydGI0NjAwZ2Ezb29xYWl1eXgwYXcifQ.jfaZl4JjTlLLgsLwNocArw"

export const MAPBOX_API_URL = "https://api.mapbox.com/"

export const SIDEBAR_WIDTH = 400
export const NAV_WIDTH = "75px"
export const TOPBAR_HEIGHT = "80px"
export const TABLE_PAGE_SIZE = 50
export const ALERT_TABLE_PAGE_SIZE = 100

// how many minutes in the past that a bike should
// still be considered "active" and to show the icon
// as the active color
export const BIKE_IS_ACTIVE_MINUTES_AGO = 3 // 3 (default) | 5 | 100 | 50000

export const MAP_STYLE_KEY = `noa:map:style${IS_PROD ? "" : `:${env}`}`
export const GMAPS_MAP_ID = `noa:gmap:id${IS_PROD ? "" : `:${env}`}`
export const GMAPS_TYPE_ID = `noa:gmap:type${IS_PROD ? "" : `:${env}`}`
export const AUTH_TOKEN = `noa:fms:token${IS_PROD ? "" : `:${env}`}`
export const REFRESH_TOKEN = `noa:fms:refresh${IS_PROD ? "" : `:${env}`}`
export const DEFAULT_ORG_KEY = `noa:fms:orgs${IS_PROD ? "" : `:${env}`}`
export const BIKE_MODELS_KEY = `noa:bike:models${IS_PROD ? "" : `:${env}`}`
export const BIKE_STATES_KEY = `noa:bike:states${IS_PROD ? "" : `:${env}`}`
export const BIKE_TAGS_KEY = `noa:bike:tags${IS_PROD ? "" : `:${env}`}`
export const BIKE_MAP_KEY = `noa:bike:map${IS_PROD ? "" : `:${env}`}`
export const BIKE_SERVICE_KEY = `noa:bike:service${IS_PROD ? "" : `:${env}`}`
export const BIKE_DROPZONE_KEY = `noa:bike:dropzone${IS_PROD ? "" : `:${env}`}`
export const BIKE_MAINTENANCE_KEY = `noa:bike:maintenance${IS_PROD ? "" : `:${env}`}`
export const ALERT_UNSELECTED_FILTERS_KEY = `noa:alert:unselectedfilters${IS_PROD ? "" : `:${env}`}`
export const MAP_PROVIDER = `noa:map:provider${IS_PROD ? "" : `:${env}`}`

export const WORLD_BBOX: Bbox = [
  [-138.5, -30.0],
  [49.7, 58.2],
]
export const VERSION = packageJson.version
export const APP_VERSION_NAME = "fms"
